if (!customElements.get('ir-blog')) {
  class IRBlog extends HTMLElement {
    constructor() {
      super();

      this.tabs    = [];
      this.items   = [];
      this.list    = null;
      this.contact = null;
      this.sort    = null;

      // 공시정보 관련
      this.disclosure = null;
      this.disclosureList = null;
      this.disclosureLoading = null;
      this.pagination = null;
      this.currentPage = 1;
      this.pageSize = 15;
      this.totalPages = 1;
      this.disclosureApiUrl = 'https://ac-api.lukuku.co/api/disclosures';

      this.activeCategory = null;
      this.onInquiryClick = this.onInquiryClick.bind(this);
      this.onHashChange   = this.onHashChange.bind(this);
    }

    connectedCallback() {
      if (this.hasAttribute('data-ir-initialized')) return;
      this.setAttribute('data-ir-initialized', 'true');

      this.cacheElements();
      if (!this.tabs.length) return;

      this.syncTabWithHash();

      this.bindEvents();
      this.bindInquiryButton();
      window.addEventListener('hashchange', this.onHashChange);
      this.updateActiveTabUI();
      this.updateView();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onInquiryClick);
      window.removeEventListener('hashchange', this.onHashChange);
    }

    cacheElements() {
      this.tabs    = Array.from(this.querySelectorAll('[data-ir-tab]'));
      this.items   = Array.from(this.querySelectorAll('[data-ir-item]'));
      this.list    = this.querySelector('[data-ir-list]');
      this.contact = this.querySelector('[data-ir-contact]');
      this.sort    = this.querySelector('[data-ir-sort]');
      this.controls = this.querySelector('[data-ir-blog-controls]');

      // 공시정보 관련 요소
      this.disclosure = this.querySelector('[data-ir-disclosure]');
      this.disclosureList = this.querySelector('[data-ir-disclosure-list]');
      this.disclosureLoading = this.querySelector('[data-ir-disclosure-loading]');
      this.pagination = this.querySelector('[data-ir-pagination]');
    }


    bindEvents() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          this.activeCategory = tab.dataset.irCategory;
          window.location.href =
          window.location.pathname +
          '#' +
          encodeURIComponent(this.activeCategory);


          this.updateActiveTabUI();
          this.updateView();
        });
      });

      if (this.sort) {
        this.sort.addEventListener('change', () => {
          this.sortItems();
        });
      }
    }

    bindInquiryButton() {
      document.addEventListener('click', this.onInquiryClick);
    }

    onInquiryClick(e) {
      const button = e.target.closest('[data-artist-inquiry-open]');
      if (!button) return;

      const value = button.getAttribute('data-modal-value');
      if (!value) return;

      console.log('Inquiry clicked, waiting for Hulk:', value);
      const iframe = document.querySelector(
        'iframe[src*="hulkapps.com"]'
      );

      if (!iframe || !iframe.contentWindow) {
        console.log('Hulk iframe not found');
        return;
      }
      const sendToHulk = () => {
        console.log('Sending form_type to Hulk:', value);

        iframe.contentWindow.postMessage(
          {
            source: 'ir-blog',
            form_type: value
          },
          '*'
        );
      };

      const onHulkReady = (event) => {
        if (event.data?.source === 'hulk' && event.data.status === 'ready') {
          window.removeEventListener('message', onHulkReady);
          sendToHulk();
        }
      };
      window.addEventListener('message', onHulkReady);
      setTimeout(sendToHulk, 800);
    }

    onHashChange() {
      this.syncTabWithHash();
      this.updateActiveTabUI();
      this.updateView();
    }

    syncTabWithHash() {
      const hash = decodeURIComponent(
        window.location.hash.replace('#', '')
      );

      const matchedTab = this.tabs.find(
        tab => tab.dataset.irCategory === hash
      );

      this.activeCategory = matchedTab
        ? matchedTab.dataset.irCategory
        : this.tabs[0].dataset.irCategory;
    }

    updateActiveTabUI() {
      this.tabs.forEach(tab => {
        tab.classList.toggle(
          'is-active',
          tab.dataset.irCategory === this.activeCategory
        );
      });
    }

    updateView() {
      const isContact = this.activeCategory === '문의';
      const isDisclosure = this.activeCategory === '공시정보';

      // 모든 섹션 숨기기
      if (this.list) this.list.style.display = 'none';
      if (this.contact) this.contact.hidden = true;
      if (this.disclosure) this.disclosure.hidden = true;

      if (isContact) {
        if (this.contact) this.contact.hidden = false;
        if (this.sort) {
          this.sort.hidden = true;
          this.sort.style.display = 'none';
        }
        if (this.controls) {
          this.controls.style.display = 'block';
        }

        this.items.forEach(item => {
          item.style.display = 'none';
        });
        return;
      }

      if (isDisclosure) {
        if (this.disclosure) this.disclosure.hidden = false;
        if (this.sort) {
          this.sort.hidden = true;
          this.sort.style.display = 'none';
        }
        if (this.controls) {
          this.controls.style.display = 'block';
        }

        this.items.forEach(item => {
          item.style.display = 'none';
        });

        // 공시정보 API 호출
        this.currentPage = 1;
        this.fetchDisclosures();
        return;
      }

      // 기본 블로그 목록 표시
      if (this.list) this.list.style.display = '';
      if (this.sort) {
        this.sort.hidden = false;
        this.sort.style.display = '';
      }
      if (this.controls) {
        this.controls.style.display = '';
      }

      this.items.forEach(item => {
        item.style.display =
          item.dataset.irCategory === this.activeCategory ? '' : 'none';
      });

      this.sortItems();
    }

    async fetchDisclosures() {
      if (!this.disclosureList || !this.disclosureLoading) return;

      this.disclosureLoading.hidden = false;
      this.disclosureList.innerHTML = '';
      if (this.pagination) this.pagination.hidden = true;

      try {
        const url = `${this.disclosureApiUrl}?page=${this.currentPage}&page_size=${this.pageSize}`;
        const response = await fetch(url, {
          headers: { 'Accept': 'application/json' }
        });

        if (!response.ok) throw new Error('API 요청 실패');

        const data = await response.json();

        if (data.status === '000' && data.list) {
          this.totalPages = data.total_page || 1;
          this.renderDisclosures(data.list);
          this.renderPagination();
        } else {
          this.disclosureList.innerHTML = '<p class="ir-blog__disclosure-empty">공시정보를 불러올 수 없습니다.</p>';
        }
      } catch (error) {
        console.error('공시정보 로딩 오류:', error);
        this.disclosureList.innerHTML = '<p class="ir-blog__disclosure-empty">공시정보를 불러오는 중 오류가 발생했습니다.</p>';
      } finally {
        this.disclosureLoading.hidden = true;
      }
    }

    renderDisclosures(list) {
      if (!this.disclosureList) return;

      const html = list.map(item => `
        <article class="ir-blog__item">
          <h3 class="ir-blog__item-title">
            <a href="${item.url}"
               class="ir-blog__item-link"
               target="_blank"
               data-open-new-window
               rel="noopener noreferrer">
              ${item.title.trim()}
            </a>
          </h3>
          <time class="ir-blog__item-date">${item.date}</time>
        </article>
      `).join('');

      this.disclosureList.innerHTML = html;
    }

    renderPagination() {
      if (!this.pagination || this.totalPages <= 1) {
        if (this.pagination) this.pagination.hidden = true;
        return;
      }

      this.pagination.hidden = false;

      const paginationList = this.pagination.querySelector('[data-ir-pagination-list]');
      const prevContainer = this.pagination.querySelector('.pagination__arrow--prev');
      const nextContainer = this.pagination.querySelector('.pagination__arrow--next');

      // Previous 버튼 업데이트
      if (prevContainer) {
        const hasPrev = this.currentPage > 1;
        prevContainer.innerHTML = hasPrev
          ? `<a href="#" data-ir-page-prev aria-label="Previous">
              <span class="pagination__arrow-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 12H5" stroke="black" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M11 4.99976L4 11.9998L11 18.9998" stroke="black" stroke-width="3" stroke-linecap="square"/>
                </svg>
              </span>
              <span class="pagination__label">Previous</span>
            </a>`
          : `<span class="disabled" data-ir-page-prev>
              <span class="pagination__arrow-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 12H5" stroke="black" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M11 4.99976L4 11.9998L11 18.9998" stroke="black" stroke-width="3" stroke-linecap="square"/>
                </svg>
              </span>
              <span class="pagination__label">Previous</span>
            </span>`;

        const prevBtn = prevContainer.querySelector('[data-ir-page-prev]');
        if (prevBtn && hasPrev) {
          prevBtn.onclick = (e) => {
            e.preventDefault();
            this.goToPage(this.currentPage - 1);
          };
        }
      }

      // Next 버튼 업데이트
      if (nextContainer) {
        const hasNext = this.currentPage < this.totalPages;
        nextContainer.innerHTML = hasNext
          ? `<a href="#" data-ir-page-next aria-label="Next">
              <span class="pagination__label">Next</span>
              <span class="pagination__arrow-icon-wrapper">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.41406 13H20.5807" stroke="black" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M14.082 5.41699L21.6654 13.0003L14.082 20.5837" stroke="black" stroke-width="3" stroke-linecap="square"/>
                </svg>
              </span>
            </a>`
          : `<span class="disabled" data-ir-page-next>
              <span class="pagination__label">Next</span>
              <span class="pagination__arrow-icon-wrapper">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.41406 13H20.5807" stroke="black" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M14.082 5.41699L21.6654 13.0003L14.082 20.5837" stroke="black" stroke-width="3" stroke-linecap="square"/>
                </svg>
              </span>
            </span>`;

        const nextBtn = nextContainer.querySelector('[data-ir-page-next]');
        if (nextBtn && hasNext) {
          nextBtn.onclick = (e) => {
            e.preventDefault();
            this.goToPage(this.currentPage + 1);
          };
        }
      }

      // 페이지 번호 업데이트 - 기존 번호 제거 후 새로 삽입
      if (paginationList && nextContainer) {
        // 기존 페이지 번호 wrapper 제거
        const existingWrapper = paginationList.querySelector('.pagination__numbers-wrapper');
        if (existingWrapper) existingWrapper.remove();

        // 새 페이지 번호를 wrapper로 감싸서 next 버튼 앞에 삽입
        const pageNumbersHtml = this.generatePageNumbers();
        const wrapperHtml = `<li class="pagination__numbers-wrapper" data-sliding-underline data-sliding-underline-height="2">${pageNumbersHtml}</li>`;
        nextContainer.insertAdjacentHTML('beforebegin', wrapperHtml);

        // 클릭 이벤트 바인딩
        paginationList.querySelectorAll('[data-page]').forEach(link => {
          link.onclick = (e) => {
            e.preventDefault();
            this.goToPage(parseInt(link.dataset.page, 10));
          };
        });

        // Sliding underline 초기화
        if (typeof initSlidingUnderlines === 'function') {
          initSlidingUnderlines();
        }
      }
    }

    generatePageNumbers() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        const isCurrent = i === this.currentPage;
        if (isCurrent) {
          pages.push(`<span class="ir-blog__pagination-text current" data-sliding-underline-item>${i}</span>`);
        } else {
          pages.push(`<a class="ir-blog__pagination_link" href="#" data-page="${i}" data-sliding-underline-item>${i}</a>`);
        }
      }

      return pages.join('');
    }

    goToPage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) return;
      this.currentPage = page;
      this.fetchDisclosures();

      // 스크롤 위치 조정
      const disclosure = this.querySelector('[data-ir-disclosure]');
      if (disclosure) {
        disclosure.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    sortItems() {
      if (!this.sort || !this.list || this.activeCategory === '문의') {
        return;
      }

      const direction = this.sort.value;

      const visibleItems = this.items.filter(
        item => item.style.display !== 'none'
      );

      visibleItems
        .sort((a, b) => {
          return direction === 'desc'
            ? Number(b.dataset.irDate) - Number(a.dataset.irDate)
            : Number(a.dataset.irDate) - Number(b.dataset.irDate);
        })
        .forEach(item => {
          this.list.appendChild(item);
        });
    }
  }

  customElements.define('ir-blog', IRBlog);

  document.addEventListener('click', (e) => {
    const subLink = e.target.closest('.menu-drawer__nav-list-sub-link');
    const subItem = e.target.closest('.menu-drawer__nav-list-sub-item');
    if (!subLink && !subItem) return;
      const headerCloser = document.querySelector('[data-header-closer]');
    if (headerCloser) {
      headerCloser.click();
    }
  });

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-open-new-window]');
    if (!link) return;
  
    e.preventDefault();  
    const url = link.href;
    if (!url) return;
  
    window.open(
      url,
      '_blank',
      'noopener,noreferrer,width=1200,height=800'
    );
  });
}
